import { render, staticRenderFns } from "./InstallationPage.vue?vue&type=template&id=55fb0f01"
import script from "./InstallationPage.vue?vue&type=script&lang=js"
export * from "./InstallationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports